<template>
  <div
    class="field"
    :class="additionalClasses"
  >
    <label :for="_uid">{{ label }}</label>
    <ValidationProvider
      v-slot="{ validate, errors }"
      :name="label"
      :rules="rules"
      :vid="vid"
    >
      <input
        :id="_uid"
        :value="value"
        :name="label"
        :type="type"
        :class="{'error': errors.length}"
        @blur="validate"
        @input="$emit('input', $event.target.value), validate($event)"
      >
      <div v-if="errors.length" class="error__text">
        {{ errors[0] }}
      </div>
    </ValidationProvider>
    <pre style="display: none">{{ value }}</pre>
  </div>
</template>

<script>
import usesValidation from '@/mixins/veeValidate'
export default {

  name: 'DSInput',

  mixins: [usesValidation],

  props: {
    label: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'text',
    },
    required: {
      type: Boolean,
      default: true,
    },
    rules: {
      type: String,
      default: 'required',
    },
    value: {
      type: String,
      default: '',
    },
    vid: {
      type: String,
      default: '',
    },
  },

  computed: {
    additionalClasses() {
      return {
        required: this.required,
      }
    },
  },
}
</script>
